var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-edit{stroke:none}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "delete_24dp",
    transform: "translate(-3123 8452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-693.815 884.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(3819.815 -9333.185)",
    style: {
      strokeWidth: 2,
      fill: "#fff",
      stroke: "#e3e9f3"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-edit",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1-2",
    "data-name": "Rectangle 1",
    transform: "translate(3825.815 -9325.185)",
    style: {
      stroke: "#0089ff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      strokeWidth: 2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fill",
    className: "cls-edit",
    d: "M0 0h6v1.5H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h6M5 0v1.5M6 1H0m1 .5V0",
    style: {
      clipPath: "url(#clip)",
      fill: "none"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.388cb1c6.svg";
export { ForwardRef as ReactComponent };